/**
 * Generated runtime TestId mirror for frontend/src/components/auto-assign/ImpactAnalysisDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ImpactAnalysisDialogTestIds = {
  btnImpactClose: "btn-impact-close",
  btnRunImpactAnalysis: "btn-run-impact-analysis",
  colAction: "col-action",
  colIdentity: "col-identity",
  colProfile: "col-profile",
  colSourceRule: "col-source-rule",
  impactAnalysisDialog: "impact-analysis-dialog",
  impactAnalysisTitle: "impact-analysis-title",
  impactCounts: "impact-counts",
  impactEmpty: "impact-empty",
  impactError: "impact-error",
  impactInputIdentityType: "impact-input-identity-type",
  impactInputMax: "impact-input-max",
  impactSelectLifecycle: "impact-select-lifecycle",
  impactTruncated: "impact-truncated",
  impactActionAdd: (index: number) => `impact-action-add-${index}`,
  impactActionAddPrefix: () => "impact-action-add-" as TestIdPrefix,
  impactActionRemove: (index: number) => `impact-action-remove-${index}`,
  impactActionRemovePrefix: () => "impact-action-remove-" as TestIdPrefix,
  impactResultRow: (index: number) => `impact-result-row-${index}`,
  impactResultRowPrefix: () => "impact-result-row-" as TestIdPrefix
} as const;
